import swal from "sweetalert";
import { queryClient } from "../queryClient";

const PostHooks = (url, data, successMsg) => {
  fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      if (data.status === "success") {
        queryClient.invalidateQueries();
        return swal(successMsg ? successMsg : "Success");
      } else {
        return swal(
          "Oops",
          `${data?.error}`,
          "error"
        );
      }
    });
};

export default PostHooks;
